// API Configuration
const API_BASE_URL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Content Monitoring
  CONTENT_SOURCES: `${API_BASE_URL}/alerts/api/content-sources/`,
  CONTENT: `${API_BASE_URL}/alerts/api/content/`,
  ANALYSIS_PROCESSES: `${API_BASE_URL}/alerts/api/analysis-processes/`,
  RUN_MONITORING: `${API_BASE_URL}/alerts/api/content-monitoring/run/`,

  // User Alerts
  USER_ALERTS: `${API_BASE_URL}/alerts/`,

  // Other endpoints can be added here
};

export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};
